import React from "react";
import { Truck } from "lucide-react";
import { useI18n } from "../i18n";

export default function AnnouncementBar() {
  const { t } = useI18n();
  const text = t("banner");

  const Group = () => (
    <div className="flex shrink-0">
      {Array.from({ length: 4 }).map((_, i) => (
        <span key={i} className="mx-8 flex items-center gap-3 font-head font-extrabold text-xs sm:text-sm tracking-wide uppercase">
          <Truck size={16} className="shrink-0" />
          {text}
        </span>
      ))}
    </div>
  );

  return (
    <div className="bg-red-600 text-white overflow-hidden border-b-[3px] border-nbblack" data-testid="announcement-bar">
      <div className="marquee-track flex py-2">
        <Group />
        <Group />
      </div>
    </div>
  );
}
